export default {
  state: {
    sideBarItems: [
      { id:1, title: "Курсы", url: "/", exact: true,  level : 0, type : 'main', enabled: true,},
      
      { id:2, title: "Курс", url: "/course/course", exact: false , level : 1, type : 'course', enabled: true},
      
      
      { id:3, title: "Видеоурок", url: "/course/video", exact: false , level:2, type : 'video', enabled: true},
      
      { id:4, title: "Упражнение", url: "/course/mode", exact: false , level:2, type : 'mode', enabled: true},   
      { id:5, title: "Прогресс", url: "/course/mode_progress", exact: false , level:2, type : 'mode', enabled: true},   
      { id:6, title: "Предложения", url: "/course/mode_satzes", exact: false , level:2, type : 'mode', enabled: true},   

    ],
  },
  getters: {
    sideBarItems(state) {
      return state.sideBarItems
    }
  },  
  mutations: {    
  },
  actions: {  
  }
}
